import Card from './Card';
import './tariffs.css';
import {cardInfo} from './cardInfo';
const Tariff = (props) => {
    const {decoders, language} = props;
    return (
        <div className='packages-tariff'>
        <div className='packages-tariff-grid-container'>
          {cardInfo[language].map(el => 
            <Card card={el} decoders={decoders}/>
          )}
        </div>
      </div>
    );
}

export default Tariff;